import { render, staticRenderFns } from "./Template50.vue?vue&type=template&id=6b9730cd&scoped=true&"
import script from "./Template50.vue?vue&type=script&lang=js&"
export * from "./Template50.vue?vue&type=script&lang=js&"
import style0 from "./Template50.vue?vue&type=style&index=0&id=6b9730cd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9730cd",
  null
  
)

export default component.exports